import React, {useState, useEffect} from 'react'
import { connect } from 'react-redux';
import { validateFile, createFoursFives } from 'actions/opkCheckerCreator'
import {
  Button,
  Modal,
} from "reactstrap";
import Spinner from 'components/common/Spinner';

const ValidationModal = (props) => {
    const {show, modalDismiss, fileID, updateTable, 
        CheckerCreator : {summary, loading, error}, 
        validateFile, createFoursFives
    } = props
  const [loadingTxt, setLoadingTxt] = useState('Trwa walidacja, proszę czekać...')
    
    useEffect(() => {
      validateFile(fileID)
    }, [fileID])

    const handleCreator = () =>  {
        setLoadingTxt('Generowanie brakujących OPK i czwórek, proszę czekać...')
        createFoursFives(fileID)
    }

    useEffect(() => {
        if(!loading) updateTable()
    }, [loading])

    const checkValidation = (summary, phase) => {
        let numberOfErrors = 0, keysToCheck = []
        switch (phase){
            case '1st':
                keysToCheck = ["sheet_checker","column_checker","data_type_checker"]
                break;
            case '2nd':
                keysToCheck = ["indirect_opk_key_checker","procedure_opk_key_checker","procedure_checker","indirect_opk_checker",
                "procedural_opk_checker","self_sending_indirect_opks","self_sending_procedural_opks","wrong_opks_in_management_keys",
                "wrong_opks_in_procedural_keys"]
                break;
            case '3rd':
                keysToCheck = ["missing_fours","missing_fives"]
                break;
            default:
                break;
        }
        keysToCheck.forEach(item => {
            numberOfErrors += summary[item].length
        })
        return numberOfErrors>0
    }

    const errorOptions = {
        indirect_opk_key_checker: "numery opk pomocniczych, które nie posiadają kluczy lub procedur do rozliczenia",
        procedure_opk_key_checker: "numery opk proceduralnych, które nie posiadają procedur do rozliczenia",
        procedure_checker: "numery użytych procedur, które nie są zdefiniowane w arkuszu 4",
        indirect_opk_checker: "numery opk niepomocniczych, które znalazły się w arkuszu 2 kolumna 3, gdzie powinny być jedynie numery opk pomocniczych",
        procedural_opk_checker: "numery opk nieproceduralnych, które znalazły się w arkuszu 3 kolumna 3, gdzie powinny być jedynie numery opk proceduralnych",
        self_sending_indirect_opks: "numery opk pomocniczych, które przekazują koszty na samych siebie",
        self_sending_procedural_opks: "numery opk proceduralnych, które przekazują koszty na samych siebie",
        wrong_opks_in_management_keys: "numery opk zarządu, które przekazują koszty na opk inne niż podstawowe",
        wrong_opks_in_procedural_keys: "numery opk proceduralnych, które przekazują koszty na opk pomocnicze"
    }

    const checkBtn = () => {
        //check if btn with 4/5 creator is needed
        if(typeof summary == typeof 'string') return false
        if(checkValidation(summary, '1st')||checkValidation(summary, '2nd')) return false 
        return checkValidation(summary, '3rd')
    }

    return(
        <Modal isOpen={show}>
            {loading ? 
                <div className="modal-header">
                    <h5 className="modal-title text-center" id="exampleModalLabel" >
                        <Spinner /><br/> {loadingTxt}            
                    </h5>
                </div>
                :
                <>
                <div className="modal-header">
                    <button className="close" type="button" onClick={()=>modalDismiss()} >
                        <span>×</span>
                    </button>
                    <h5 className="modal-title text-center" id="exampleModalLabel" >
                        Podsumowanie walidacji
                    </h5>
                </div>
                {error?
                    <>
                    <div className="modal-body ">
                        Błędny lub niezabezpieczony plik. Zalecane jest pobranie szablonu pliku.
                    </div>
                    <div className="modal-footer">
                        <div className="left-side">
                            <Button className="btn-link" color="default" type="button" onClick={() => modalDismiss()} >
                            Zamknij
                            </Button>
                        </div>
                    </div>
                    </>
                    :
                    <>
                    <div className="modal-body">{typeof summary == typeof 'string'?<>{summary}</>:<>
                        {checkValidation(summary, '1st')?
                        <>
                            Niepoprawny szablon danych:
                            <ul>
                                {summary.sheet_checker.length>0 &&<li>
                                    numery arkuszy niezgodnych z szablonem: {summary.sheet_checker.join(', ')}
                                </li>}
                                {summary.column_checker.length>0 &&<li>
                                    niepoprawne nazwy kolumn: {summary.column_checker.join(', ')}
                                </li>}
                                {summary.data_type_checker>0 &&<li>
                                    niepoprawny typ danych: {summary.map((item)=> {return `arkusz ${item[1]} kolumna ${item[0]}`}).join(', ')}
                                </li>}
                            </ul>
                        </>:<>
                            {checkValidation(summary, '2nd')?<>
                                Niepoprawne dane:
                                <ul>
                                    {Object.entries(errorOptions).map(([key, value], i) => {
                                        if(summary[key].length>0){
                                            return (<li>{`${value}: ${summary[key].join(', ')}`}</li>)
                                        }
                                    })}
                                </ul>
                            </>:<>
                                {checkValidation(summary, '3rd')?<>
                                    Brakujące OPK/czwórki:
                                    <ul>
                                        {summary.missing_fours.length>0 &&<li>
                                            brakujące czwórki: {summary.missing_fours.join(', ')}
                                        </li>}
                                        {summary.missing_fives.length>0 &&<li>
                                            brakujące OPK: {summary.missing_fives.join(', ')}
                                        </li>}
                                    </ul>
                                </>:<>
                                    Zweryfikowano dane, plik gotowy do importu.
                                </>}
                            </>}
                        
                        </>}</>}
                    </div>
                    <div className="modal-footer">
                        <div className="left-side">
                            {checkBtn()?
                                <Button className="btn-link" color="default" type="button" onClick={() => handleCreator()} >
                                    Wygeneruj brakujące OPK/czwórki
                                </Button>:<Button className="btn-link" color="default" type="button" onClick={() => modalDismiss()} >
                                    Rozumiem
                                </Button>
                            }
                            
                        </div>
                    </div>
                    </>
                }          
                </>
            }
        </Modal>
    )
}

const mapStateToProps = state => ({
    CheckerCreator: state.CheckerCreator,
})

export default connect(mapStateToProps , {validateFile, createFoursFives})(ValidationModal)
